"use strict";
var transform = require('common/transform');
var hlp = require('common/helpers');
var controller = function($scope, $rootScope, $http, Flash) {
  $scope.save = function() {
    create();
  };
  $scope.selectOption = function(option) {
    $scope.option = option;
    if (option == 'all') {
      $scope.collectionName = null;
    }
  };
  var create = function() {
    $scope.loading = true;
    var params = {
      collectionName: $scope.collectionName,
      exportThesaurus: $scope.exportThesaurus,
      exportPictures: $scope.exportPictures,
      filename: $scope.filename
    };
    $http.post('/api/export/document.json', angular.toJson(params)).then(function(response) {
      $scope.loading = false;
      window.location = '/export';
    }, function(response) {
      var msg = "Unkown";
      if (hlp.isSet(response.data.message)) {
        msg = response.data.message;
      }
      var message = '<strong>Fehler beim Export! (' + msg + ')</strong>.';
      Flash.create('danger', message, '');
      $scope.loading = false;
    });
  };
  var getCollectionList = function() {
    var params = {};
    $http.get('/api/collection.json', {params: params}).then(function(response) {
      $scope.collectionsList = response.data.collections;
    }, function(response) {});
  };
  var init = function() {
    $scope.option = 'all';
    getCollectionList();
  }();
};
module.exports = controller;
